module.exports = {
  //B2BServiceFee: 499,
  B2BGST: 18,
  APILOCALURL: "https://localhost:7231/api/",
  APISERVERURL: "https://trawtelvisa.azurewebsites.net/api/",
  APIACTIVATEURL: "https://trawtelvisa.azurewebsites.net/api/",
  // APIACTIVATEURL: 'https://localhost:7231/api/',

  SENDOTP: "home/userotp",
  VERIFYOTP: "home/verifyotp",

  PAYMENTORDERREQUEST: "Payment/Process",

  GETORDERSBYUSERID: "user",
  UPDATEUSER: "user",
  GETUSER: "User",

  CREATEVISAREQUEST: "visaRequest/Create",
  UPDATEVISAREQUEST: "visaRequest",
  UPDATEMULTIPLEVISAREQUEST: "visaRequest/UpdateMultiple",
  GETVISAREQUESTBYUSER: "visaRequest/GetByUserId",
  GETVISAREQUESTBYID: "visaRequest",
  GETMULTIPLEVISAREQUEST: "visaRequest/GetMultipleVisaRequests",
  CREATEVISAAPPLICANT: "VisaApplicant/Create",
  GETVISAAPPLICANTSBYVISAREQUEST: "VisaApplicant/GetByVisaRequest",

  UPDATEVISAAPPLICANT: "VisaApplicant/Update",
  DELETEAPPLICANTDOCUMENT: "VisaApplicant/DeleteDocument",

  SEARCHVISAREQUEST: "VisaRequest/Search",
  GETDASHBOARDDATA: "VisaRequest/GetDashboardData",
  GETPENDINGPAYMENTSBYID: "VisaRequest/PendingPaymentsById",
  GETVISAHISTORY: "VisaRequest/GetHistoryByRequestId",

  GETALLNEWS: "News/GetAll",
  GETNEWS: "News",
  UPDATENEWS: "News",
  GETNEWSBYID: "News",
  DELETENEWS: "News",
  CREATENEWS: "News/Create",

  GETSUPPLIERS: "supplier/GetAll",

  EXTRACT_PASSPORT_DATA: "ocr/extract-text",
};
